import InputTooltip from './presentation.js';

export default InputTooltip;
